import mutations from "./mutations";
import state from "./state";
import actions from "./actions";
import { Cart } from "@/types/Cart";
import User from "@/models/User";
import IProduct from "@/models/protocols/IProduct";

export interface RootState {
  cart: Cart;
  user: User;
  products: Array<IProduct>;
  regions: {};
}

export default {
  actions,
  mutations,
  state: state as RootState,
  namespaced: true,
};
